import { render, staticRenderFns } from "./luxury-residences-in-londons-center.vue?vue&type=template&id=7890a468&"
import script from "./luxury-residences-in-londons-center.vue?vue&type=script&lang=js&"
export * from "./luxury-residences-in-londons-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports